// @core/api/endpoints/team/get_team_role_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamRoleApplicationResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get role application details
 * Retrieves the details of a specific role change application including current and requested roles.
 */
export async function GetTeamRoleApplication(
  request_id: string,
  options?: RequestOptions
): Promise<GetTeamRoleApplicationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/role-applications/:request_id`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.get<GetTeamRoleApplicationResponse>(requestPath, { ...requestOptions });
}
